<template>
  <div id="container">
    <transition name="calendar" :enter-class="animationDirectionNext ? 'calendar-enter-next' : 'calendar-enter-prev'">
      <day-cell-table
        class="calendar"
        :key="animation"
        :month="month" :year="year"
        :avvisi="avvisi"
        @update-view="(from, to) => { $emit('update-view', from, to) }"
        @click:cell="onCellClick"/>
    </transition>

    <toggleable-menu
      ref="dayCellMenu"
      with-activator
      :close-on-click="false"
      bottom
      :nudge-left="30"
      :nudge-top="20"
      :nudge-width="60"
      max-width="240">
      <div slot="data" slot-scope="{ data, index }" class="day-menu">

        <v-tooltip bottom>
          <v-btn :id="'add' + index" slot="activator" icon flat color="accent" @click="$emit('click:add', 'add' + index, data.date)">
            <v-icon>add</v-icon>
          </v-btn>
          <span>{{ $t('avvisi.azioni.nuovo') }}</span>
        </v-tooltip>

        <span class="display-2 mb-2">{{ data.day }}</span>

        <div class="avvisi-list">
          <alert-chip :id="'a' + avviso.id" :key="index" v-for="(avviso, index) in data.avvisi"
                      block dense gradient class="mb-1" closeable :color="avviso.colore"
                      @click:close="$emit('click:delete', avviso.id)"
                      @click="$emit('click:edit', avviso)">
            <b class="mr-1">{{ avviso.ora_avviso }}</b>
            <span class="word-break">{{ avviso.testo }}</span>
          </alert-chip>
        </div>
      </div>
    </toggleable-menu>

  </div>
</template>

<script>
import currentDateMixin from './calendar-mixin'
import DayCellTable from './DayCellTable'
import ToggleableMenu from '@/components/base/ToggleableMenu'

export default {
    name: 'CalendarContent',
    mixins: [currentDateMixin],
    components: { DayCellTable, ToggleableMenu },
    props: {
        avvisi: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            animationDirectionNext: false,
            animation: false,
            lastChangeTimestamp: Number(new Date())
        }
    },
    mounted () {
        this.$el.addEventListener('wheel', this.onScroll, { passive: true })
        window.addEventListener('keyup', this.onKeyUp)
    },
    beforeDestroy () {
        this.$el.removeEventListener('wheel', this.onScroll)
        window.removeEventListener('keyup', this.onKeyUp)
    },
    watch: {
        internalValue (newVal, oldVal) {
            this.animationDirectionNext = oldVal < newVal

            let now = new Date()
            //  Permetto l'animazione ogni 300 ms
            if (now - this.lastChangeTimestamp > 300) {
                this.animation = !this.animation
            }
            this.lastChangeTimestamp = now
            this.$refs.dayCellMenu.close()
        }
    },
    methods: {
        onCellClick (activatorId, date, avvisi) {
            this.$refs.dayCellMenu.show(activatorId, { day: date.getDate(), date, avvisi })
        },
        onScroll (e) {
            if (e.deltaY < 0 || e.deltaX < 0) { //  Up
                this.goToPrevMonth()
            } else if (e.deltaY > 0 || e.deltaX > 0) { //  Down
                this.goToNextMonth()
            }
        },
        onKeyUp (e) {
            if (e.key === 'ArrowLeft') this.goToPrevMonth()
            else if (e.key === 'ArrowRight') this.goToNextMonth()
        },
        closeMenus () {
            this.$refs.dayCellMenu && this.$refs.dayCellMenu.close()
        }
    }
}
</script>

<style lang="scss" scoped>
  #container {
    width: 100%;
    height: calc(100% - 72px);
  }

  .day-menu {
    $day-menu--min-height: 150px;
    $day-menu--max-height: 400px;

    min-height: $day-menu--min-height;
    padding: 12px 0 12px 16px;

    .avvisi-list {
      min-height: $day-menu--min-height - 72px;
      max-height: $day-menu--max-height;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .v-btn {
      z-index: 9;
      position: absolute;
      right: 38px;
      top: 0;
    }

  }

  //  Animazione calendario nel cambio data
  $duration: .3s;
  $translation: 30px;

  .calendar, .calendar-enter-active, .calendar-leave-active {
    position: absolute;
    left: 8px;
    right: 8px;
    height: calc(100% - 80px);
    width: calc(100% - 16px);
    will-change: transform, opacity;
    transition: transform $duration, opacity $duration;
  }

  .calendar-enter-prev {
    opacity: 0;
    transform: translateX(-$translation);
  }

  .calendar-enter-next {
    opacity: 0;
    transform: translateX($translation);
  }
</style>
